/**
 * Resolve API base URL for axios/fetch.
 * Production (non-localhost): use same-origin /api so requests match page protocol (HTTPS).
 * Local dev: use REACT_APP_API_URL or http://localhost:3002.
 */
export function getApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const { hostname, protocol } = window.location;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

    if (!isLocal) {
      return '/api';
    }

    const envUrl = process.env.REACT_APP_API_URL;
    if (envUrl?.startsWith('http://') && protocol === 'https:') {
      return envUrl.replace(/^http:\/\//, 'https://').replace(/\/$/, '');
    }
  }

  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  return 'http://localhost:3002';
}
